import { useState } from "react"
import { Dropdown } from "react-bootstrap"
import { useAuth } from "../api/auth/store"
import CompanySettings from "./CompanySettings/CompanySettings"

const Account = () => {
    const [showSettings, setShowSettings] = useState(false)
    const { user, loading, logout } = useAuth( state => state)
    
    if (loading) {
        return <></>
    }
    
    const handleLogout = async () => {
        try {
            await logout()
            window.location.href = '/login' // Redirect to login page after logout

            // Redirect to login page after successful logout
            //redirectToLogin()
        } catch (error) {
            console.error('Logout error:', error)
            // Even if logout fails, redirect to login
            //redirectToLogin()
        }
    }
    
    const handleShowSettings = () => {
        setShowSettings(true)
    }
    
    return (
        <>
            <div style={{position: "absolute", right: 10}}>
                <Dropdown>
                    <Dropdown.Toggle size="sm" variant="outline-secondary" id="dropdown-basic">
                        {user?.dis || user?.uname || 'User'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleShowSettings}>Settings</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={handleLogout}>Sign Out</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            
            <CompanySettings 
                show={showSettings} 
                onHide={() => setShowSettings(false)} 
            />
        </>
    )
}

export default Account